import { ReactNode } from 'react';

import { DOCUMENT_TYPE } from 'api/documents/documents.model';
import CardRow from 'components/CardRow';
import GoToCertificateButton from 'components/GoToCertificateButton';
import { useCertificatesQuery } from 'hooks/useCertificatesQuery';

type RelatedDocumentProps = {
  relatedDocumentProductId?: string;
  children?: ReactNode;
};

const RelatedDocument = ({ relatedDocumentProductId, children }: RelatedDocumentProps) => {
  const { data, isLoading } = useCertificatesQuery(
    {
      productId: relatedDocumentProductId,
      documentType: DOCUMENT_TYPE.PUBLIC,
    },
    {
      enabled: !!relatedDocumentProductId,
    }
  );

  return (
    <CardRow>
      {children}
      <GoToCertificateButton
        documentBlockchainAddress={data?.rows[0]?.documentBlockchainAddress}
        isLoading={isLoading}
      />
    </CardRow>
  );
};

export default RelatedDocument;
